export { GAP_PERIOD_MONTHS_OPTIONS as EMPLOYMENT_GAP_PERIOD_MONTHS_OPTIONS } from "../experience-verification-templates/utils";
export { GAP_THRESHOLD_UNIT_OPTIONS } from "../experience-verification-templates/utils";

export const FCA_FIRM_REFERENCE_NUMBER_PATTERN = /^[0-9]{6,7}$/;

export const EMPLOYMENT_VERIFICATION_TEMPLATE_CONFIG = {
  // YEARS
  MINIMUM_YEARS: 1,
  MAXIMUM_YEARS: 10,
  DEFAULT_YEARS: 5,
  // MINIMUM EMPLOYERS
  MINIMUM_EMPLOYERS_MINIMUM: 1,
  DEFAULT_MINIMUM_EMPLOYERS: 1,
  // MAXIMUM EMPLOYERS
  MAXIMUM_EMPLOYERS_MAXIMUM: 10,
  DEFAULT_MAXIMUM_EMPLOYERS: 5,
};
